import React, { FC } from 'react';
import { useOrganizationQuery } from '../../../api/queries/use-organization-query';
import { EditCreateComponentProps, Formula } from '../../../types';
import { OrgQueryKeys } from '../../../api/config';
import { L } from 'harmony-language';
import { useAddOrganizationResourceMutation } from '../../../api/mutations/add/use-add-organization-resource-mutation';
import { useEditOrganizationResourceMutation } from '../../../api/mutations/edit/use-edit-organization-resource-mutation';
import { ResourcePage } from '../resource-page';
import { useFormulaColumns } from './use-formula-columns';
import { EditCreateFormula } from './edit-create-formula';

export const FormulaManagement: FC = () => {
    const { data: medications, isLoading } = useOrganizationQuery<Formula[]>(OrgQueryKeys.formulas);
    const { mutateAsync: addFormula, isLoading: isCreating } = useAddOrganizationResourceMutation(OrgQueryKeys.formulas, L.formula());
    const { mutateAsync: editFormula, isLoading: isUpdating } = useEditOrganizationResourceMutation(OrgQueryKeys.formulas, L.formula());
    const columns = useFormulaColumns();

    return (
        <ResourcePage
            resourceType='formula'
            isLoading={isLoading || isCreating || isUpdating}
            titleFunc={(formula: Formula) => formula.name}
            data={medications}
            columns={columns}
            EditCreateComponent={(editCreateProps: EditCreateComponentProps<Formula>) =>
                <EditCreateFormula
                    existingFormula={editCreateProps.resource}
                    closeModal={editCreateProps.closeModal}
                    addFormula={addFormula}
                    editFormula={editFormula}
                />
            }
        />
    );
};
